const setGatewayCustomer = (accountNbr, userData, registrationDate, country,singOnResponse) => {
    let customerName = {};
    if(singOnResponse?.gatewayCustomer?.name?.firstName){
        const firstName = singOnResponse?.gatewayCustomer?.name?.firstName;
        const lastName = singOnResponse?.gatewayCustomer?.name?.lastName;
        customerName = {
            "firstName": firstName, 
            "lastName":lastName
        }
        window.sessionStorage.setItem('FirstName', firstName);
        window.sessionStorage.setItem('LastName', lastName);  
    }
    
    let gateWayCustomer = {
      "address": {
        "addrLine1": singOnResponse?.gatewayCustomer?.address?.addrLine1,
        "city": singOnResponse?.gatewayCustomer?.address?.city,
        "countryIsoCode": singOnResponse?.gatewayCustomer?.address?.countryIsoCode,
        "postalCode": singOnResponse?.gatewayCustomer?.address?.postalCode,
        "state": singOnResponse?.gatewayCustomer?.address?.state
      },
      "email": userData.emailId,
      "fbMsgEnabled": singOnResponse?.gatewayCustomer?.fbMsgEnabled,
      "mobilePhone": {
          "phoneNumber": {}
      },
      "name": customerName,
      "preferredCustomer": {
          "accountNbr": accountNbr
      },
      "r3Login": singOnResponse?.gatewayCustomer?.r3Login,
      "termsConditionFlag": singOnResponse?.gatewayCustomer?.termsConditionFlag,
      "identityVerificationStatus": singOnResponse?.gatewayCustomer?.identityVerificationStatus,
      "verificationStatus": singOnResponse?.gatewayCustomer?.verificationStatus,
      "registrationDate": registrationDate,
      "registrationStatus": singOnResponse?.gatewayCustomer?.registrationStatus,
      "additionalPreferredCustomers": {
          "preferredCustomer": {
              accountNbr
          }
      },
      "customerCategory": singOnResponse?.gatewayCustomer?.customerCategory
    }
    window.sessionStorage.setItem('GatewayCustomer', JSON.stringify(gateWayCustomer))
  }

  const setR3SendeGatewayrDetails =  (sessionId, encryptedSessionId, country, lang, userData, singOnResponse, successType = 'sc_register_success') => {
    try {
      const accNumber = singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr;
      const registrationDate = singOnResponse?.gatewayCustomer?.registrationDate;
      const registrationStatus = singOnResponse?.gatewayCustomer?.registrationStatus;
      let sender = {};
      if(accNumber){
        sender = {
            "email": singOnResponse?.gatewayCustomer?.email,
            "verifyMfaFlow": "register",
            "isSWBProfile": false,
            "fbMsgEnabled": singOnResponse?.gatewayCustomer?.fbMsgEnabled,
            "verificationStatus": singOnResponse?.gatewayCustomer?.verificationStatus,
            "termsConditionFlag": singOnResponse?.gatewayCustomer?.termsConditionFlag,
            "myWuNumber": accNumber,
            "isLoggedIn": true,
            "address": {
              "addrLine1": singOnResponse?.gatewayCustomer?.address?.addrLine1,
              "city": singOnResponse?.gatewayCustomer?.address?.city,
              "countryIsoCode": singOnResponse?.gatewayCustomer?.address?.countryIsoCode,
              "postalCode": singOnResponse?.gatewayCustomer?.address?.postalCode,
              "state": singOnResponse?.gatewayCustomer?.address?.state
            },
            "registrationDetails": {
              "registrationDate":registrationDate,
              "registrationStatus": registrationStatus
            },
            "mobileNumber": {},
            "accountPreferences": {
              "optInShape": singOnResponse?.gatewayCustomer?.accountPreferences?.optInShape,
              "message": singOnResponse?.gatewayCustomer?.accountPreferences?.message,
              "email": singOnResponse?.gatewayCustomer?.accountPreferences?.email,
              "optOutMarketing": singOnResponse?.gatewayCustomer?.accountPreferences?.optOutMarketing,
              "directMail": singOnResponse?.gatewayCustomer?.accountPreferences?.directMail,
              "telephoneCall": singOnResponse?.gatewayCustomer?.accountPreferences?.telephoneCall,
              "optInShare": singOnResponse?.gatewayCustomer?.accountPreferences?.optInShare,
              "featureEnable": singOnResponse?.gatewayCustomer?.accountPreferences?.featureEnable,
            },
            "firstName": singOnResponse?.gatewayCustomer?.name?.firstName,
            "lastName": singOnResponse?.gatewayCustomer?.name?.lastName,
            "identityVerificationStatus": singOnResponse?.gatewayCustomer?.identityVerificationStatus,
            "verificationStatusActualVal": singOnResponse?.gatewayCustomer?.verificationStatus,
            "r3Login": singOnResponse?.gatewayCustomer?.r3Login,
            "registrationStatus": registrationStatus,
            "receiverCount":singOnResponse?.gatewayCustomer?.receiverCount,
            "transactionCount": singOnResponse?.gatewayCustomer?.transactionCount,
            "showThirdPartyConsentPopup": singOnResponse?.gatewayCustomer?.showThirdPartyConsentPopup
        }
      } 
      const data = {
        sessionId: sessionId,
        encryptedSessionId: encryptedSessionId,
        sender: sender
      };
      const jsonData = JSON.stringify(data);
      window.sessionStorage.setItem('app', jsonData);
      window.sessionStorage.setItem("AccountNumber", accNumber);
      window.sessionStorage.setItem("cookiestore", jsonData);
      window.sessionStorage.setItem(successType, true);
      CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
      CookieService.setCookie('EncryptedSessionId', encryptedSessionId, 30, `/${country}/${lang}`, true, ".westernunion.com");
      setGatewayCustomer(accNumber, userData, registrationDate, country,singOnResponse);
    } catch(e) {
      console.log(e)
    }

  }

const setR3LoyalityCard = (loyalityResponse) => {
    const custdata = loyalityResponse?.gateway_customer?.additional_preferred_customers?.preferred_customer;
    let preferredCustomer = {};
    custdata?.forEach((loyalityRElement) => 
        preferredCustomer = {
            "accountNbr": loyalityRElement?.account_nbr,
            "issueDate": loyalityRElement?.issue_date,
            "lastUseDate": loyalityRElement?.last_use_date,
            "levelCode": loyalityRElement?.level_code,
            "totalPointsEarned": loyalityRElement?.total_points_earned,
            "promoCode": loyalityRElement?.promo_code,
        }
    );
    let resLoyalityCard = {
        "gatewayCustomer": {
            "additionalPreferredCustomers": {
                "preferredCustomer": preferredCustomer
            }
        }
      }
    if(loyalityResponse?.rewardList){
        resLoyalityCard["rewardList"] = loyalityResponse?.rewardList;
    }
    window.sessionStorage.setItem('resLoyalityCard', JSON.stringify(resLoyalityCard))
}

const setR3CustomerVerificationStatus = (customerVerificationResponse) => {
    let customerVerificationStatus = {
        "isEligibleToTransact": customerVerificationResponse?.isEligibleToTransact,
        "customerStatus": customerVerificationResponse?.customerStatus,
        "UnstructuredData": customerVerificationResponse?.UnstructuredData,
        "Status": {
            "code": customerVerificationResponse?.Status?.code
        },
        "wACH": customerVerificationResponse?.wACH,
        "paymentType": customerVerificationResponse?.paymentTypes?.payment_type,
        "identityVerificationStatus": customerVerificationResponse?.identity_verification_status,
      }
      window.sessionStorage.setItem('CustomerVerificationStatus', JSON.stringify(customerVerificationStatus))
}

const setDataInStorageR4 = (customerProfile, signInData, lang, userData, country, r4SessionId, r4encryptedSessionId, r4ClientIp, r4dataCenter) => {
    const timestamp = new Date().valueOf().toString();
    CookieService.setCookie('LangCode', lang, 365, '/')
    CookieService.setCookie('SessionInfo', timestamp, 365, '/', true, '.westernunion.com')
    CookieService.setCookie('UserID', userData.emailId, 365, '/')
    CookieService.setCookie('NewUserCookie', true, 365, '/')
    CookieService.setCookie('loggedIn', true, 365, '/')
    CookieService.setCookie('CountryCode', country, 365, '/')
    CookieService.setCookie('userType', "newCustomer", 365, '/')
    CookieService.setCookie('SessionId', r4SessionId, 365, '/', true, '.westernunion.com')
    CookieService.setCookie('UserLocale', `${lang}-${country.toUpperCase()}`, 365, '/')
    
    const registrationDate = customerProfile?.data?.customerProfile?.customer?.registrationDate
    const expiresIn = signInData?.data?.signIn?.token?.expiresIn
    const accessToken = signInData?.data?.signIn?.token?.accessToken
    const expireTime = "" !== expiresIn ? (0,
        Date.now)() + 1e3 * parseInt(expiresIn) : 0;
    const accountNbr = customerProfile?.data?.customerProfile?.customer?.accountNumber
    const expiry = new Date().getTime() + (15 * 60 * 1000) - (5 * 1000)
    const expiresAt = new Date().getTime() + (10 * 60000) // i.e. 14 minutes and 55 seconds considering 5 secs for response delays.
    const accessTokenData = {
        "expiresAt": expiresAt,
        "accessToken": accessToken
    }

    let state = {
        "loginSuccess": {
            "loggedIn": true,
            "gatewayCustomer": {
                "email": userData.emailId,
                "preferred_customer": {
                    "account_nbr": accountNbr
                },
                "gender": "",
                "nationality": "",
                "occupation": "",
                "terms_condition_flag": true,
                "imageUrl": null,
                "industry": null,
                "registration_status": "P",
                "name": {
                    "first_name": "",
                    "last_name": ""
                },
                "address": {
                    "country_iso_code": country
                },
                "registration_date": registrationDate,
                "identity_verification_status": "N",
                "account_preferences": {
                    "email": true,
                    "direct_mail": null,
                    "telephone_call": null,
                    "message": null,
                    "opt_out_marketing": true,
                    "thirdparty_datasharing_consent": null
                }
            }
        },
        "MYWU": {
            "myWUDetails": 
            {
                "accountNumber": accountNbr,
                "pointsEarned":0
            }
        },
        "updatedUserDetails": {
            "gatewayCustomer": {
                "email": userData.emailId,
                "preferred_customer": {
                    "account_nbr": accountNbr
                },
                "gender": "",
                "nationality": "",
                "occupation": "",
                "terms_condition_flag": true,
                "imageUrl": null,
                "industry": null,
                "registration_status": "P",
                "address": {
                    "country_iso_code": country
                },
                "registration_date": registrationDate,
                "identity_verification_status": "N",
                "account_preferences": {
                    "email": true,
                    "direct_mail": null,
                    "telephone_call": null,
                    "message": null,
                    "opt_out_marketing": true,
                    "thirdparty_datasharing_consent": null
                }
            }
        },
        "session": {
            "session": {
                "id": r4SessionId,
                "encrypted_session_id": r4encryptedSessionId
            },
            "data_center": r4dataCenter || "rs",
            "client_ip": r4ClientIp,
            "response_header": [],
            "expiry": expiry 
        },
        "digitalCustomerProfile": {
            "id": accountNbr,
            "email": userData.emailId,
            "imageUrl": null,
            "name": {
                "first": "",
                "last": "",
                "middle": null,
                "prefix": null,
                "suffix": null,
                "maternal": null,
                "paternal": null
            },
            "address": {
                "city": null,
                "stateCode": null,
                "addressLine1": null,
                "addressLine2": null,
                "postalCode": null,
                "countryCode": country.toUpperCase()
            },
            "complianceData": {
                "comments": null,
                "complianceType": null,
                "cuba": false,
                "docReceived": false,
                "documents": [],
                "employerName": null,
                "identityVerificationStatus": "N",
                "maritalStatus": null,
                "pepCategory": null,
                "pepRelation": false,
                "personalIdentificationNumber": null,
                "verifications": []
            },
            "countryOfBirth": null,
            "credential": null,
            "notification": {
                "email": true,
                "mail": null,
                "marketing": true,
                "optInShare": null,
                "phone": null,
                "sms": null,
                "thirdpartyDatasharingConsent": null
            },
            "payment": {
                "wallets": null,
                "cards": null,
                "banks": null
            },
            "accountNumber": accountNbr,
            "occupation": null,
            "employment": {
                "industry": null,
                "level": null,
                "name": null,
                "status": null
            },
            "annualIncomeBracket": null,
            "gender": null,
            "nationality": null,
            "dateOfBirth": null,
            "placeOfBirth": null,
            "registrationDate": registrationDate,
            "registrationStatus": "P",
            "termsConditions": true,
            "nameMatchIndicator": false,
            "optInReferAFriendFlag": null,
            "phoneNumber": null
        },
        "customerAccessToken": accessToken,
        "customerRefreshToken": {
            "refreshToken": signInData?.data?.signIn?.token?.refreshToken,
            "expiresIn": expiresIn,
            "expireTime": expireTime
        },
        isUserLoginWithMobileNumber: false,
        account_login: userData.emailId,
        user_journey: "sending_money",
        accesstoken: accessTokenData,
        registrationDate: registrationDate,
        AccountNumber: accountNbr,
        Email: userData.emailId
    }

    const STATE_EXPIRY_TIME = 1800000;
    const expiryStateExpired = new Date(new Date().getTime() + STATE_EXPIRY_TIME);
    sessionStorage.setItem('stateExpiredAt',expiryStateExpired.getTime().toString());



    window.sessionStorage.setItem('accesstoken', JSON.stringify(accessTokenData))
    window.sessionStorage.setItem('state', JSON.stringify(state))
    window.sessionStorage.setItem('r4state', JSON.stringify(state))

    setGatewayCustomer(accountNbr, userData, registrationDate, country?.toUpperCase())

    const pathArray = window?.location?.pathname?.split('/');
    const senderCountry = (pathArray && pathArray[1]) || ""
    sessionStorage.setItem("sendercountry", senderCountry);
    const countryLanguage = (pathArray && pathArray.length >= 2 && pathArray[2]) || "";
    sessionStorage.setItem("countryLanguage", countryLanguage);
}
